import { CommonInventoryType } from '@dynamika-shared/types/inventory';
import { RESTClient, RESTClientMock } from './client';
import { USE_API_MOCKS } from '../env';
import {
  fetchDiseasesMock,
  fetchLocationsMock,
  fetchPhasesMock,
  fetchSponsorsMock,
  fetchTherapeuticAreasMock
} from '@api/mocks/inventory';
import { API_URL } from '@api/apiDictionary';

const api = USE_API_MOCKS ? RESTClientMock : RESTClient;

export const fetchSponsors = async () => {
  if (USE_API_MOCKS) {
    fetchSponsorsMock();
  }
  return api.get<CommonInventoryType[]>(API_URL.sponsors);
};

export const fetchTherapeuticAreas = async () => {
  if (USE_API_MOCKS) {
    fetchTherapeuticAreasMock();
  }
  return api.get<CommonInventoryType[]>(API_URL.therapeutic);
};

export const fetchPhases = async () => {
  if (USE_API_MOCKS) {
    fetchPhasesMock();
  }
  return api.get<CommonInventoryType[]>(API_URL.phases);
};

export const fetchDiseases = async () => {
  if (USE_API_MOCKS) {
    fetchDiseasesMock();
  }
  return api.get<CommonInventoryType[]>(API_URL.diseases);
};
export const fetchLocations = async () => {
  if (USE_API_MOCKS) {
    fetchLocationsMock();
  }
  return api.get<CommonInventoryType[]>(API_URL.locations);
};
